import { render, staticRenderFns } from "./updatePaymentOptionDesc.vue?vue&type=template&id=87386464&lang=pug"
import script from "./updatePaymentOptionDesc.vue?vue&type=script&lang=js"
export * from "./updatePaymentOptionDesc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports